import { Row, Space, message } from "antd";
import React, { useEffect, useRef, useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { useDispatch, useSelector } from "react-redux";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { DEFAULT_HOME_PAGE_FEEDS, FILE_STATUS, THUMBNAIL_TYPES } from "../../helpers/constant";
import { getSuggestionByType } from "../../redux/CreatorSuggestion/CreatorSuggestion";
import { getHomePageFeeds, loadMorePageFeeds } from "../../redux/feeds/feedsSlice";
import { AppDispatch, StoreState } from "../../redux/store";
import { authService, userService } from "../../services";
import SuggestionSectionFour from "../FanHomeSuggestionComponent/FanHomeSuggestionSectionsComponent/SuggestionSectionFour";
import MainSwiperSlideItemV2 from "../MainSwiperSlideItemV2/MainSwiperSlideItemV2";
import { FanHomePageSkelton } from "../SkeltonsComponents/FanHomePageSkelton";
import SpinnerComponent from "../SpinnerComponent/SpinnerComponent";
import "./index.less";
import FanHomeAdComponent from "../FanHomeAdComponent/FanHomeAdComponent";
import { subscriptionsService, utilService } from "../../services";

const S3_HOME_AD_URL = "https://twizz-scripts.s3.us-east-1.amazonaws.com/home.txt";

interface Props {
  onRefresh?: () => void;
}

const MainSwiper = (props: Props) => {
  const { t } = useTranslation();
  const shouldFetch = useRef(true);
  const dispatch = useDispatch<AppDispatch>();
  const { homeFeeds, loadingHome: loading, error, totalPages } = useSelector((state: StoreState) => state.feeds);
  //const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const selectionWeek = useSelector((state: StoreState) => state.suggestion.suggestionByTypeList.get(4) || []);
  const [creatorSubscriptions, setCreatorSubscriptions] = useState(false);
  const [followers, setFollowers] = useState(-1);
  const [showSelectionOfWeek, setShowSelectionOfWeek] = useState(true);
  const showAds = useFeatureFlagEnabled("advertisements");
  const shouldShowAds = showAds !== false;

  useEffect(() => {
    console.log("Home Feature flag loaded - showAds:", showAds, "shouldShowAds:", shouldShowAds);
  }, [showAds, shouldShowAds]);
  const [adContent, setAdContent] = useState<string>("");

  useEffect(() => {
    if (shouldFetch.current) {
      shouldFetch.current = false;
      if (homeFeeds.length === 0) {
        dispatch(getHomePageFeeds(1));

        if (!selectionWeek.length) {
          dispatch(getSuggestionByType(4));
        }
      }
    }
  }, []);

  useEffect(() => {
    if (homeFeeds.length !== 0 && totalPages !== -1) {
      setHasNextPage(
        Math.ceil(homeFeeds.length / DEFAULT_HOME_PAGE_FEEDS) < totalPages || Math.ceil(homeFeeds.length / DEFAULT_HOME_PAGE_FEEDS) !== totalPages
      );
    }
  }, [homeFeeds, totalPages]);

  useEffect(() => {
    if (loading === "failed" && error) {
      message.error("Something went wrong.");
    }
  }, [loading, error]);

  useEffect(() => {
    if ((homeFeeds.length <= 10 || followers <= 3) && !["pending", "idle"].includes(loading)) {
      setCreatorSubscriptions(true);
    } else {
      setCreatorSubscriptions(false);
    }
  }, [homeFeeds, followers, loading]);

  useEffect(() => {
    if (homeFeeds.length > 3) {
      setShowSelectionOfWeek(false);
    } else {
      setShowSelectionOfWeek(true);
    }
  }, [homeFeeds]);

  useEffect(() => {
    subscriptionsService
      .allSubscriptions(100, 0)
      .then((response: any) => {
        console.log("Subscription  data:", response.total);

        setFollowers(response.total);
      })
      .catch((error) => {
        message.error(t("something-want-wrong"));
      });

    userService
      .getFollowedCreator()
      .then((data: any) => {
        console.log("Followed creators data:", data);
      })
      .catch((error: any) => {
        message.error(error || t("something-want-wrong"));
      });

    const fetchAdContent = async () => {
      const content = await utilService.getAdContent(S3_HOME_AD_URL);
      if (content) {
        setAdContent(content);
      }
    };
    fetchAdContent();
  }, []);

  const loadMoreFeeds = () => {
    if (hasNextPage) {
      dispatch(loadMorePageFeeds(Math.ceil(homeFeeds?.length / DEFAULT_HOME_PAGE_FEEDS) + 1));
    }
  };

  const [sentryRef] = useInfiniteScroll({
    loading: loading === "pending",
    hasNextPage: hasNextPage,
    onLoadMore: loadMoreFeeds,
  });

  const handleRefresh = async () => {
    await dispatch(getHomePageFeeds(1));
    //setPage(1);
    setHasNextPage(false);
  };

  return (
    <>
      {loading === "pending" && <FanHomePageSkelton loading={loading === "pending"} />}
      {homeFeeds.length > 0 && (
        <PullToRefresh
          isPullable={true}
          onRefresh={handleRefresh}
          resistance={4}
          pullDownThreshold={90}
          pullingContent={
            <Row className="mt-20 mb-20 d-flex justify-content-center">
              <div className="beat-loader">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </Row>
          }
        >
          <>
            {homeFeeds?.map((feed, index) => {
              let thumbnail = "";
              let fileUrl = "";
              let isUploading: boolean = false;
              if (feed.files !== undefined) {
                isUploading = feed.files[0].status === FILE_STATUS.UPLOADING;
                if (!feed.isPrivateForCurrentUser) {
                  fileUrl = feed.files[0].url!;
                  thumbnail = feed.files[0].thumbnails?.find((thumb) => thumb.type === THUMBNAIL_TYPES.CLEAR)?.absolutePath!;
                } else {
                  thumbnail = feed.files[0].thumbnails?.find((thumb) => thumb.type === THUMBNAIL_TYPES.BLURRED)?.absolutePath!;
                  fileUrl = thumbnail;
                }
              }
              if (isUploading) {
                return "";
              }

              const shouldInsertSelectionOfTheWeek = index === 3;

              return (
                <Fragment key={`feed-wrapper-${feed._id || index}`}>
                  {shouldInsertSelectionOfTheWeek && (
                    <Space direction="vertical" className="suggestionPageWrapper m-negativ-50">
                      <SuggestionSectionFour creatorSuggestionSection={selectionWeek} />
                    </Space>
                  )}
                  <MainSwiperSlideItemV2
                    refProp={null}
                    feedId={feed._id!}
                    key={feed._id}
                    name={feed.creatorInfo?.name!}
                    username={feed.creatorInfo?.username!}
                    avatar={feed.creatorInfo?.avatar!}
                    creatorId={feed.creatorInfo?._id}
                    totalLikes={feed.totalLike}
                    fileUrl={fileUrl}
                    thumbnail={thumbnail}
                    isLiked={feed.isLiked}
                    isBookMarked={feed.isBookMarked}
                    isPrivate={feed.isPrivateForCurrentUser}
                    description={feed.text!}
                    verifiedAccount={feed.creatorInfo?.verifiedAccount}
                    type={feed.type!}
                    isCurrentUser={feed.creatorInfo?._id === authService.getId()}
                    isFanHomePage={true}
                    isUploading={isUploading}
                    creatorIds={feed?.creatorIds || []}
                  />
                  {(index + 1) % 4 === 0 && followers === 0 && shouldShowAds && <FanHomeAdComponent adContent={adContent} key={`home-ad-${index}`} />}
                  {/* {(index + 1) % 4 === 0 && followers === 0 && adContent && <FanHomeAdComponent adContent={adContent} key={`home-ad-${index}`} />} */}
                </Fragment>
              );
            })}
          </>
        </PullToRefresh>
      )}
      {(loading === "pending" || hasNextPage) && (
        <Row className="next-page-loading">
          <SpinnerComponent refProp={sentryRef} />
        </Row>
      )}
    </>
  );
};

export default MainSwiper;
